export type LiveNotesStatus = 'idle' | 'checking' | 'live' | 'unavailable' | 'not-linked';

export interface LiveNotesSnapshot {
    isFetching: boolean;
    isError: boolean;
    errorStatus: number | null;
    notes: string | null;
}

// The backend answers a patient with no DM link with 409, the same as on save.
const DM_NOT_LINKED_STATUS = 409;

export function liveNotesStatus(live: LiveNotesSnapshot): LiveNotesStatus {
    if (live.isFetching) return 'checking';
    if (live.isError) {
        return live.errorStatus === DM_NOT_LINKED_STATUS ? 'not-linked' : 'unavailable';
    }
    return live.notes === null ? 'idle' : 'live';
}

export function freshestNotes(syncedNotes: string | null, live: LiveNotesSnapshot): string | null {
    return liveNotesStatus(live) === 'live' ? live.notes : syncedNotes;
}
